import { useApi } from '~/restAPI';
import { Cart } from '~/restAPI/Cart';
import { Orders } from '~/restAPI/Orders';

export function useCart() {
  const { createApiInstance } = useApi();
  const cartApi = createApiInstance(Cart);
  const ordersApi = createApiInstance(Orders);

  function changeSizeOrCount(query:{ orderPositionId?: number; sizeId?: number; count?: number }) {
    return cartApi.changePositionSizeOrCountUsingPatch(query, { format: 'json' })
      .then((data) => data!.data!.data!);
  }

  function addToWishList(orderPositionId: number) {
    return cartApi.deletePositionUsingDelete(orderPositionId, { format: 'json' })
      .then((data) => data!.data!.data!);
  }

  function getUnfinishedOrders() {
    return ordersApi.getUnfinishedOrdersUsingGet({ format: 'json' })
      .then((data) => data!.data!.data);
  }

  function deleteOrder(orderId: number) {
    return ordersApi.deleteOrderUsingDelete(orderId, { format: 'json' })
      .then((data) => data!.data!.data!);
  }

  return {
    changeSizeOrCount,
    addToWishList,
    getUnfinishedOrders,
    deleteOrder,
  };
}
